// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__gdWds","tooltiptext":"Tooltip_tooltiptext__qHthp"};